import { Box } from 'theme-ui';
import { lighten } from '@theme-ui/color';

export default function Tab({ isActive, sx= {}, children, ...props }) {
  return (
    <Box
      sx={{
        fontSize: 'large',
        color: isActive ? '#fff' : 'primary',
        textShadow: 'none',
        backgroundColor: isActive ? 'secondary' : 'rgba(0,0,0,0.02)',
        mr: 1,
        mb: 1,
        p: '8px 12px',
        borderRadius: '5px',
        outline: '0',
        cursor: isActive ? undefined : 'pointer',
        ':hover': {
          backgroundColor: isActive ? undefined : 'rgba(0,0,0,0.1)',
          transition: 'background-color 0.3s'
        },
        whiteSpace: 'nowrap',
        border: isActive ? undefined : 'solid 1px',
        borderColor: lighten('secondary', 0.6),
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  )
}
